/* @flow */

import * as React from 'react';
import * as Sentry from '@sentry/react';

import Error500 from './Error500';

type Props = {
  children: React.Node,
};

type State = {
  sentryId: string,
  error: ?Error,
  errorInfo: ?Object,
};

class ErrorBoundry extends React.PureComponent<Props, State> {
  state = {
    sentryId: '',
    error: null,
    errorInfo: null,
  };

  componentDidCatch(error: Error, errorInfo: Object) {
    Sentry.configureScope((scope) => scope.setExtras(errorInfo));

    const sentryId = Sentry.captureException(error);

    this.setState({ sentryId, error, errorInfo });
  }

  render() {
    const { sentryId, error, errorInfo } = this.state;

    if (error) {
      return (
        <Error500
          sentryId={sentryId}
          error={error}
          errorInfo={errorInfo}
        ></Error500>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundry;
